
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const DonationSection = () => {
  return (
    <div className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-blue-500/10 to-purple-500/10 p-8 md:p-12">
      <div className="absolute inset-0 bg-grid-white/10" />
      <div className="relative z-10 text-center space-y-6">
        <div className="inline-block p-3 bg-pink-500/10 rounded-2xl">
          <Heart className="w-8 h-8 text-pink-500" />
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
          Soutenez Notre Mission
        </h2>
        
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Votre soutien nous aide à continuer d'améliorer nos services et à rendre les soins de santé plus accessibles à tous.
        </p>
        
        <Button 
          size="lg" 
          className="bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white"
          asChild
        >
          <Link to="/donation">
            Faire un don
            <Heart className="w-4 h-4 ml-2" />
          </Link>
        </Button>
      </div>
    </div>
  );
};
